(() => {
  'use strict';
  const root = document.querySelector('#p3-son,#p3-sister,#p3-granddaughter,#p3-everlasting,#p3-first-ten,#p3-completion,#p3-completion-ring,#p3-necklace,#aa-p3-signature-pilot');
  if (!root || document.getElementById('aa-p3-info-modal')) return;
  const pagePaths = new Set([
    '/pages/made-to-order-products-refund-and-return-policy',
    '/pages/ring-size-chart', '/pages/ring-size-guide',
    '/pages/jewelry-care-guide',
    '/pages/the-awareness-avenue-lifetime-shine-warranty',
    '/pages/frequently-asked-questions-awareness-avenue'
  ]);
  const style = document.createElement('style');
  style.textContent = `#aa-p3-info-modal{position:fixed;inset:0;margin:auto;width:min(760px,calc(100vw - 32px));max-width:none;max-height:calc(100dvh - 32px);padding:0;border:1px solid #dfd8cc;background:#fffefb;color:#292a24;box-shadow:0 20px 80px #0004;font:16px/1.65 Arial,Helvetica,sans-serif;overflow:auto;overscroll-behavior:contain}#aa-p3-info-modal::backdrop{background:#0008}#aa-p3-info-modal *{box-sizing:border-box}#aa-p3-info-modal .p3-info-header{position:sticky;top:0;z-index:1;display:flex;align-items:center;gap:16px;justify-content:space-between;padding:16px 22px;border-bottom:1px solid #dfd8cc;background:#fffefb}#aa-p3-info-modal h2{font:400 25px/1.2 Georgia,serif;margin:0}#aa-p3-info-modal .p3-info-close{display:grid;place-items:center;flex:0 0 44px;width:44px;height:44px;padding:0;border:1px solid #d0c8ba;background:transparent;color:inherit;font:26px/1 Arial;cursor:pointer}#aa-p3-info-modal .p3-info-body{padding:22px;overflow-wrap:anywhere}#aa-p3-info-modal .p3-info-body h1,#aa-p3-info-modal .p3-info-body h2,#aa-p3-info-modal .p3-info-body h3,#aa-p3-info-modal .p3-info-body h4{font-family:Georgia,serif;line-height:1.3;margin:22px 0 12px}#aa-p3-info-modal .p3-info-body p,#aa-p3-info-modal .p3-info-body li{font-size:16px;line-height:1.65}#aa-p3-info-modal .p3-info-body p{margin:0 0 16px}#aa-p3-info-modal .p3-info-body ul,#aa-p3-info-modal .p3-info-body ol{padding-left:24px}#aa-p3-info-modal img,#aa-p3-info-modal video{max-width:100%;height:auto}#aa-p3-info-modal table{display:block;max-width:100%;overflow:auto}#aa-p3-info-modal a{text-decoration:underline;text-underline-offset:3px}#aa-p3-info-modal button:focus-visible,#aa-p3-info-modal a:focus-visible{outline:2px solid #5e7548;outline-offset:3px}#aa-p3-info-modal .p3-info-retry{min-height:44px;padding:10px 18px;border:1px solid #292a24;background:#292a24;color:white;font:inherit;cursor:pointer}@media(max-width:600px){#aa-p3-info-modal{width:calc(100vw - 20px);max-height:calc(100dvh - 20px)}#aa-p3-info-modal .p3-info-header,#aa-p3-info-modal .p3-info-body{padding:16px}#aa-p3-info-modal h2{font-size:23px}}`;
  document.head.append(style);
  const dialog = document.createElement('dialog');
  dialog.id = 'aa-p3-info-modal';
  dialog.setAttribute('aria-labelledby', 'aa-p3-info-title');
  dialog.innerHTML = '<header class="p3-info-header"><h2 id="aa-p3-info-title"></h2><button type="button" class="p3-info-close" aria-label="Close information">×</button></header><div class="p3-info-body" id="aa-p3-info-content" aria-live="polite"></div>';
  document.body.append(dialog);
  const title = dialog.querySelector('h2'), content = dialog.querySelector('.p3-info-body');
  const cache = new Map();
  let trigger = null, controller = null, sequence = 0, previousOverflow = '', previousScroll = {x: 0, y: 0};
  function informational(url) {
    const path = url.pathname.replace(/\/$/, '').replace(/^\/(?:[a-z]{2}(?:-[a-z]{2,})?)\//i, '/');
    return url.origin === location.origin && (path.startsWith('/policies/') || pagePaths.has(path));
  }
  function clean(source, url) {
    const doc = new DOMParser().parseFromString(source, 'text/html');
    const body = doc.querySelector('.shopify-policy__body') || doc.querySelector('.shopify-section--main-page .prose') || doc.querySelector('main article .prose') || doc.querySelector('main article');
    if (!body || !body.textContent.trim()) throw Error('Information could not be loaded.');
    const copy = body.cloneNode(true);
    copy.querySelectorAll('script,style,link,iframe,object,embed,base,meta,noscript,form').forEach(el => el.remove());
    copy.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(a => { if (/^on/i.test(a.name) || a.name === 'srcdoc') el.removeAttribute(a.name); });
      ['href', 'src'].forEach(attr => {
        const value = el.getAttribute(attr);
        if (!value) return;
        const resolved = new URL(value, url);
        if (!['http:', 'https:', 'mailto:', 'tel:'].includes(resolved.protocol)) el.removeAttribute(attr);
        else el.setAttribute(attr, resolved.href);
      });
    });
    return copy;
  }
  async function open(link) {
    const url = new URL(link.href, location.href), request = ++sequence;
    controller?.abort();
    controller = new AbortController();
    if (!dialog.open) {
      trigger = link;
      previousOverflow = document.documentElement.style.overflow;
      previousScroll = {x: window.scrollX, y: window.scrollY};
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
    title.textContent = link.textContent.trim() || 'Information';
    content.replaceChildren();
    content.textContent = 'Loading…';
    content.setAttribute('aria-busy', 'true');
    dialog.scrollTop = 0;
    try {
      let source = cache.get(url.href);
      if (!source) {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw Error('Information could not be loaded.');
        source = await response.text();
      }
      const body = clean(source, url.href);
      if (request !== sequence || !dialog.open) return;
      cache.set(url.href, source);
      content.replaceChildren(body);
    } catch (error) {
      if (error.name === 'AbortError' || request !== sequence || !dialog.open) return;
      content.innerHTML = '<p>This information could not load. Please try again; your product selections are still here.</p><button type="button" class="p3-info-retry">Try again</button>';
      content.querySelector('button').addEventListener('click', () => open(link));
    } finally {
      if (request === sequence) content.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (!informational(url)) return;
    event.preventDefault();
    open(link);
  });
  dialog.querySelector('.p3-info-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    sequence++;
    controller?.abort();
    document.documentElement.style.overflow = previousOverflow;
    trigger?.focus({preventScroll:true});
    window.scrollTo({left: previousScroll.x, top: previousScroll.y, behavior: 'instant'});
  });
})();
